<template>
  <template v-if="currencyDetail">
    <Meta
      name="twitter:title"
      :content="
        $t(`path-of-exile-2-boost.currencies.${currencyDetail.slug}_title`)
      "
    />
    <Meta
      name="twitter:description"
      :content="
        $t(
          `path-of-exile-2-boost.currencies.${currencyDetail.slug}_description`
        )
      "
    />
    <Meta
      name="og:description"
      :content="
        $t(
          `path-of-exile-2-boost.currencies.${currencyDetail.slug}_description`
        )
      "
    />
    <Meta
      name="og:title"
      :content="
        $t(`path-of-exile-2-boost.currencies.${currencyDetail.slug}_title`)
      "
    />

    <div class="d-flex-column flex-65 justify-start align-start t-white gap-0">
      <!-- CURRENCY DETAIL -->
      <div class="currency_detail_head b-radius-12 gap-18 md-hide">
        <img
          :src="currencyDetail.icon"
          alt="currency_icon"
          class="currency_icon b-radius-9"
        />
        <div class="d-flex-column justify-start align-start gap-18">
          <div class="d-flex-column justify-start align-start gap-9">
            <h3 class="t-white font-family-2 bold-xxxxl">
              {{ currencyDetail.title }}
            </h3>
            <div
              class="caps bold-m t-grey font-family-2 currency_chip b-radius-5"
            >
              {{ $t("dashboard.currency") }}
            </div>
          </div>
          <p class="regular-l font-family-2 t-grey">
            {{ currencyDetail.description }}
          </p>
        </div>
      </div>

      <div class="currency_detail_head b-radius-12 gap-18 above-md-hide">
        <div class="d-flex-row justify-start gap-18">
          <img
            :src="currencyDetail.icon"
            alt="currency_icon"
            class="currency_icon mobile b-radius-9"
          />
          <div class="d-flex-column justify-start align-start gap-6">
            <h3 class="t-white font-family-2 bold-xl">
              {{ currencyDetail.title }}
            </h3>
            <div
              class="caps bold-m t-grey font-family-2 currency_chip b-radius-5"
            >
              {{ $t("dashboard.currency") }}
            </div>
          </div>
        </div>
        <p class="regular-l font-family-2 t-grey">
          {{ currencyDetail.description }}
        </p>
      </div>

      <!-- CURRENCY PRICES -->
      <div class="currency_details_container">
        <div
          class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
        >
          <label class="t-light regular-m font-family-2">{{
            $t("new.price")
          }}</label>
          <div class="d-flex-row justify-start">
            <CurrencyIcon />
            <CurrencyPrice :price="currencyDetail.price" />
          </div>
        </div>

        <div
          class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
        >
          <label class="t-light regular-m font-family-2">{{
            $t("new.min_purchase")
          }}</label>
          <div class="d-flex-row justify-start">
            <CartBlueIcon />
            <label class="bold-l font-family-2 t-white">{{
              currencyDetail?.minimum_quantity
            }}</label>
          </div>
        </div>

        <div
          class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
        >
          <label class="t-light regular-m font-family-2">{{
            $t("new.in_stock")
          }}</label>
          <div class="d-flex-row justify-start">
            <CurrencyIcon />
            <label class="bold-l font-family-2 t-white">{{
              currencyDetail?.stock
            }}</label>
          </div>
        </div>

        <div
          class="gold_detail flex-3 d-flex-column justify-start align-start gap-10"
        >
          <label class="t-light regular-m font-family-2">{{
            $t("new.guranteed_delivery")
          }}</label>
          <div class="d-flex-row justify-start">
            <ShieldTimeIcon />
            <label class="bold-l font-family-2 t-white">
              {{ handleTiming(currencyDetail?.timing) }}{{ " " }}
              {{ handleTiminglabel(currencyDetail?.timing) }}
            </label>
          </div>
        </div>
      </div>

      <!--  -->
      <OrbPicker
        :title="currencyDetail.title"
        :icon="currencyDetail.icon"
        :in_stock="currencyDetail?.stock"
        :min_quantity="currencyDetail.minimum_quantity"
      />
      <DifficultPicker />
      <!-- PLATFORM -->
      <PlatformPicker style="margin-top: 36px" />
    </div>

    <!-- CART -->
    <div
      class="d-flex-column flex-2 justify-start align-start t-white cart_container"
    >
      <WhyWeCheap />
      <Cart />
      <SafeSecurePayments />
    </div>
  </template>
</template>
<script setup>
import Cart from "../../checkout/Cart.vue";
import SafeSecurePayments from "../../checkout/SafeSecurePayments.vue";
import CurrencyIcon from "~/components/icons/CurrencyIcon.vue";
import CurrencyPrice from "~/components/common/table/CurrencyPrice.vue";
import CartBlueIcon from "~/components/icons/CartBlueIcon.vue";
import ShieldTimeIcon from "~/components/icons/ShieldTimeIcon.vue";
import PlatformPicker from "../../commonpickers/PlatformPicker.vue";
import DifficultPicker from "../pickers/DifficultPicker.vue";
import OrbPicker from "../pickers/OrbPicker.vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";
import SeasonLength from "~/components/custom/SeasonLength.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const { t, locale } = useI18n();

const showSeasonLength = computed(() => {
  if (!gameStore.getGame?.id) return false;
  if (gameStore.getGame?.game_season?.id) return true;
  return false;
});

const props = defineProps({
  activeCurrency: {
    default: "",
  },
});
const difficultyOptions = computed(() => {
  const options =
    gameStore.getGamePack?.pack_options?.filter(
      (op) => op.const_title === "hard_core" || op.const_title === "soft_core"
    ) || [];
  return options;
});

const currencyDetail = computed(() => {
  if (!props.activeCurrency) return;
  const currency = gameStore.getGamePack.prices?.find(
    (price) => price.slug === props.activeCurrency
  );
  if (currency) return currency;
  return null;
});

const handleTiminglabel = (timing) => {
  if (!timing || typeof timing !== "number") return;
  if (timing < 60) {
    return t("minutes");
  } else if (timing < 1440) {
    return t("order.card.hours");
  } else {
    const days = timing / 1440;
    return `${t("app.day")}${days > 1 ? "(s)" : ""}`;
  }
};
const handleTiming = (timing) => {
  if (timing < 60) {
    return `${timing}`;
  } else if (timing < 1440) {
    const hours = timing / 60;
    return `${parseFloat(hours.toFixed(1))}`;
  } else {
    const days = timing / 1440;
    return `${parseFloat(days.toFixed(1))}`;
  }
};

const handleDetail = () => {
  checkoutStore.clearCheckout();

  const stock =
    currencyDetail.value.stock < 15 ? currencyDetail.value.stock : 15;

  checkoutStore.setDetails({
    numberOfOrbs: currencyDetail.value.minimum_quantity,
    orbId: currencyDetail.value.id,
  });
  if (difficultyOptions.value) {
    // checkoutStore.setDifficulty(difficultyOptions.value[0]?.id);
    checkoutStore.setPackOptions({ options: [difficultyOptions.value[0]?.id] });
  }

  checkoutStore.setPlatform({
    platform: 1,
  });

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetail();

onMounted(() => {
  checkoutStore.setCalculating();
});
useSeoMeta({
  title: t(
    `path-of-exile-2-boost.currencies.${currencyDetail.value.slug}_title`
  ),
  description: t(
    `path-of-exile-2-boost.currencies.${currencyDetail.value.slug}_description`
  ),
});

watch(currencyDetail, (newVal) => {
  checkoutStore.setDetails({
    numberOfOrbs: newVal.minimum_quantity,
    orbId: newVal.id,
  });
  useSeoMeta({
    title: t(`path-of-exile-2-boost.currencies.${newVal.slug}_title`),
    description: t(
      `path-of-exile-2-boost.currencies.${newVal.slug}_description`
    ),
  });
});
</script>

<style lang="scss">
.currency_detail_head {
  width: 100%;
  padding: 12px;
  height: max-content;
  border: 1px solid var(--stroke-dark);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .currency_chip {
    padding: 3px 6px;
    background-color: rgba(255, 255, 255, 0.05);
  }
  .currency_icon {
    // width: 100%;
    width: 100%;
    height: auto;
    max-width: 280px;
    object-fit: cover;
    &.mobile {
      height: 56px;
      width: 56px;
      max-width: 56px;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    .currency_icon {
      max-width: 100%;
    }
  }
}
.currency_details_container {
  margin-top: 36px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto, 1fr);
  grid-column-gap: 9px;
  grid-row-gap: 9px;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    margin-top: 30px;
  }
}
</style>
